import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button, EmptyState, Spinner } from "@/ui";
import { useMatchCard } from "../lib/hooks";
import { MatchDetail } from "../components/MatchDetail";
import { PageFrame } from "../components/PageFrame";

export function MatchDetailPage() {
  const { matchId } = useParams<{ matchId: string }>();
  const navigate = useNavigate();
  const { card, isLoading } = useMatchCard(matchId);
  return (
    <PageFrame
      title={card?.display.title ?? "Introduction"}
      subtitle={card?.display.subtitle}
      actions={
        <Button variant="ghost" icon={<ArrowLeft size={14} />} onClick={() => navigate("/matches")}>
          All introductions
        </Button>
      }
    >
      {isLoading ? (
        <div className="u-row" style={{ justifyContent: "center", padding: 40 }}>
          <Spinner />
        </div>
      ) : card ? (
        <div style={{ maxWidth: 720 }}>
          <MatchDetail card={card} onClose={() => navigate("/matches")} />
        </div>
      ) : (
        <EmptyState title="This introduction is no longer available">It may have been dismissed or it expired.</EmptyState>
      )}
    </PageFrame>
  );
}
